module.exports = __webpack_public_path__ + "static/img/advantage_2.7b49002.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customized_service/advantage_2.png
// module id = SQU5
// module chunks = 94